import * as React from 'react';
import { Translate } from '../../../../../../shared/LanguageService';
import history from '../../../../../../shared/history';
import BaseTab from './BaseTab';

type PhotographerOrdersTabProps = {
    label: string;
};

const PhotographerOrdersRoute = '/orders-list/photographer';
let routes = [PhotographerOrdersRoute];

function PhotographerOrdersTab({ label, ...props }: PhotographerOrdersTabProps) {
    function handleClick() {
        history.push(PhotographerOrdersRoute);
    }

    return (
        <BaseTab {...props} onClick={handleClick} label={label} route={PhotographerOrdersRoute} />
    );
}

function TranslatedPhotographerOrdersTab(props) {
    const label = Translate('header/nav/photographers-photo-orders-list');
    return <PhotographerOrdersTab {...props} label={label} />;
}

TranslatedPhotographerOrdersTab.routes = routes;

export default TranslatedPhotographerOrdersTab;
